import {connect} from 'react-redux'

import {adPageUrlSelector, adProductSelector, isProductOwnerSelector} from 'data/redux/selectors/productSelector';
import {isProductOrderOwnerSelector} from 'data/redux/selectors/orderSelector';
import AdControlTopLine from 'gui/pages/mainRouter/pages/ad/components/commons/adControlTopLine';

const mapStateToProps = (state, ownProps) => {
  const product = adProductSelector(state);
  const {id, ...restParsedUrl}: any = adPageUrlSelector(state);
  return {
    product: product,
    isProductOwner: isProductOwnerSelector(state),
    isOrderOwner: isProductOrderOwnerSelector(product)(state),
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch, ...ownProps) => {
  return {...ownProps};
};

const AdControlTopLineContainer = connect(mapStateToProps, mapDispatchToProps)(AdControlTopLine);

export default AdControlTopLineContainer;
